export var EField;
(function (EField) {
    EField["Header"] = "_header";
    EField["Info"] = "info";
    EField["BanqupInfo"] = "banqupInfo";
    EField["TenantAmount"] = "tenantAmount";
    EField["TenantBankAccountId"] = "tenantBankAccountId";
    EField["OwnerAmount"] = "ownerAmount";
    EField["OwnerBankAccountId"] = "ownerBankAccountId";
    EField["BrokerAmount"] = "brokerAmount";
    EField["BrokerBankAccountId"] = "brokerBankAccountId";
    EField["Signers"] = "signers";
    EField["SignAsBroker"] = "signAsBroker";
    EField["Broker"] = "broker";
    EField["TenantReceiver"] = "tenantReceiver";
    EField["OwnerReceiver"] = "ownerReceiver";
    EField["JudicialRelease"] = "judicialRelease";
    EField["VerdictPdf"] = "verdictPdf";
    EField["LeaseContractDocument"] = "leaseContractDocument";
    EField["Payer"] = "payer";
    EField["DocumentType"] = "documentType";
    EField["IdentityDocuments"] = "identityDocuments";
    EField["PayerIdentityDocuments"] = "payerIdentityDocuments";
    EField["IdentityDocumentAccountId"] = "accountId";
    EField["PayerIdentityDocumentAccountId"] = "payerAccountId";
    EField["IdentityDocumentIdentityFrontDocumentId"] = "identityFrontDocument";
    EField["IdentityDocumentIdentityBackDocumentId"] = "identityBackDocument";
    EField["DateOfExpiry"] = "dateOfExpiry";
    EField["DocumentNumber"] = "documentNumber";
    EField["CountryOfIssuance"] = "countryOfIssuance";
    EField["DateOfIssuance"] = "dateOfIssuance";
})(EField || (EField = {}));
export var EBanqupRentioDocumentType;
(function (EBanqupRentioDocumentType) {
    EBanqupRentioDocumentType["IdCard"] = "ID_CARD";
    EBanqupRentioDocumentType["Passport"] = "PASSPORT";
})(EBanqupRentioDocumentType || (EBanqupRentioDocumentType = {}));
